<template>
  <div>

    <SelectYear v-if="!selected" @change="selected = true" />
    <index-chart v-else></index-chart>
    <!-- <index-chart v-if="indexStyle==1"></index-chart> -->
    <!-- <index-bdc v-if="indexStyle==2"></index-bdc>
    <index-task v-if="indexStyle==3"></index-task> -->
<!--    <div style="width: 100%;text-align: right;margin-top: 20px">-->
<!--      请选择首页样式：-->
<!--      <a-radio-group v-model="indexStyle">-->
<!--        <a-radio :value="1">统计图表</a-radio>-->
<!--        <a-radio :value="2">统计图表2</a-radio>-->
<!--        <a-radio :value="3">任务表格</a-radio>-->
<!--      </a-radio-group>-->
<!--    </div>-->
  </div>
</template>

<script>
  import IndexChart from './IndexChart'
  import IndexTask from "./IndexTask"
  import IndexBdc from './IndexBdc'
  import SelectYear from './SelectYear'
  export default {
    name: "Analysis",
    components: {
      IndexChart,
      IndexTask,
      IndexBdc,
      SelectYear
    },
    data() {
      return {
        selected: false,
        indexStyle:1
      }
    },
    created() {
      const year = this.$store.state.online.year
      if (year != 0) {
        this.selected = true
      }
    },
    methods: {

    }
  }
</script>